import React, { useState, useEffect } from 'react';
import {  FaWallet, FaMoneyBillWave, FaListAlt, FaCommentDots, FaMobileAlt } from 'react-icons/fa';
import FilterInput from '../../Components/FilterInput';
import Button from '../../Components/Button';
import Alert from '../../Components/Alert';
import Loading from '../../Components/Loading';
import { handlePhoneInputKeyPress } from '../../Utils/validateForm';
import { calculateFinalAmount, calculateBaseAmount } from '../../Utils/walletCalculations';
import useWalletTransfer from '../../Hooks/Wallet/useWalletTransfer';

const TransferFromWalletToWallet = () => {
  const { values, errors, error, success, isLoading, handleChange, handleSubmit } = useWalletTransfer();

  const [category, setCategory] = useState('');
  const [finalAmount, setFinalAmount] = useState('');
  const [lastEditedField, setLastEditedField] = useState(null); // amount | finalAmount

  useEffect(() => {
    if (!category) return;

    if (lastEditedField === 'amount_sp' && values.amount_sp) {
      setFinalAmount(calculateFinalAmount(values.amount_sp, category));
    } else if (lastEditedField === 'finalAmount' && finalAmount) {
      handleChange({
        target: { name: 'amount_sp', value: calculateBaseAmount(finalAmount, category) }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.amount_sp, finalAmount, category, lastEditedField]);

  return (
    <div className="w-full bg-light p-6">
    

      {/* النموذج */}
      <form className="space-y-4" onSubmit={handleSubmit}>
        {/* رقم الهاتف */}
        <div className="relative">
          <FilterInput
            label="رقم الهاتف"
            type="text"
            name="phone_number"
            placeholder="ادخل رقم الهاتف"
            value={values.phone_number}
            onChange={handleChange}
            onKeyPress={(e) => handlePhoneInputKeyPress(e, e.target.value)}
            error={errors.phone_number}
          />
          <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
            <FaMobileAlt className="text-main1 opacity-90" />
          </div>
        </div>

        {/* المبلغ + الفئة + المبلغ الواجب دفعه */}
        <div className="grid grid-cols-9 gap-3">
          {/* المبلغ */}
          <div className="col-span-3">
            <div className="relative">
              <FilterInput
                label="المبلغ"
                type="number"
                name="amount_sp"
                placeholder="المبلغ"
                value={values.amount_sp}
                onChange={(e) => {
                  handleChange(e);
                  setLastEditedField('amount_sp');
                }}
                error={errors.amount_sp}
              />
              <div className="absolute left-2 top-1/2 transform -translate-y-1/2">
                <FaWallet className="text-main1 opacity-90 text-sm" />
              </div>
            </div>
          </div>

          {/* الفئة */}
          <div className="col-span-3">
            <div className="relative">
              <select
                value={category}
                onChange={(e) => setCategory(e.target.value)}
                className="w-full px-3 py-2 pr-8 rounded-xl border border-grayish bg-grayish text-gray-500 focus:outline-none focus:ring-1 focus:ring-main1 font-cairo text-sm transition-all duration-200 h-[45px] appearance-none"
              >
                <option value="">اختر الفئة</option>
                {Array.from({ length: 11 }, (_, i) => i + 1).map((num) => (
                  <option key={num} value={num}>
                    الفئة {num}
                  </option>
                ))}
              </select>
              <label className="absolute right-3 top-0 text-xs text-main1 font-medium bg-light px-1 transform -translate-y-1/2 pointer-events-none">
                الفئة
              </label>
              <div className="absolute left-2 top-1/2 transform -translate-y-1/2">
                <FaListAlt className="text-main1 opacity-90 text-sm" />
              </div>
            </div>
          </div>

          {/* المبلغ الواجب دفعه */}
          <div className="col-span-3">
            <div className="relative">
              <FilterInput
                label="المبلغ الواجب دفعه"
                type="number"
                placeholder="0"
                value={finalAmount}
                onChange={(e) => {
                  setFinalAmount(e.target.value);
                  setLastEditedField('finalAmount');
                }}
              />
              <div className="absolute left-2 top-1/2 transform -translate-y-1/2">
                <FaMoneyBillWave className="text-main1 opacity-90 text-sm" />
              </div>
            </div>
          </div>
        </div>

        {/* اختيار الدين */}
        <div className="flex items-center space-x-2">
          <input
            type="checkbox"
            name="is_debt"
            checked={values.is_debt}
            onChange={handleChange}
            className="w-3.5 h-3.5 outline-none"
            style={{ accentColor: '#1C4130' }}
          />
          <label className="text-main1 text-md font-medium pr-1 mb-2 mt-2 flex items-center">
            دين
          </label>
        </div>

        {/* المبلغ المدفوع يظهر فقط إذا دين */}
        {values.is_debt && (
          <div className="relative">
            <FilterInput
              label="المبلغ المدفوع"
              type="number"
              name="amount_paid"
              placeholder="ادخل المبلغ المدفوع"
              value={values.amount_paid}
              onChange={handleChange}
              error={errors.amount_paid}
            />
            <div className="absolute left-2 top-1/2 transform -translate-y-1/2">
              <FaMoneyBillWave className="text-main1 opacity-90 text-sm" />
            </div>
          </div>
        )}

        {/* الملاحظات */}
        <div className="relative">
          <FilterInput
            label="الملاحظات (اختياري)"
            type="textarea"
            name="note"
            placeholder="اكتب ملاحظة هنا..."
            value={values.note}
            onChange={handleChange}
          />
          <div className="absolute left-3 top-8">
            <FaCommentDots className="text-main1 opacity-90" />
          </div>
        </div>

        {/* زر الإرسال */}
        <Button type="submit" className="mt-6" disabled={isLoading}>
          {isLoading ? (
            <div className="flex items-center gap-3 m-1">
              <Loading type="dots" size="md" text="جاري الإرسال ..." color="light" />
            </div>
          ) : (
            'إرسال'
          )}
        </Button>
      </form>

      {/* الرسائل */}
      {error && <Alert type="error">{error}</Alert>}
      {success && <Alert type="success">{success}</Alert>}
    </div>
  );
};

export default TransferFromWalletToWallet;
